import React from "react";

import { Sparkline } from "../../graphs/inline";

export default class Stats extends React.Component {
  getStats() {
    return {
      earnings: {
        total: "$ 6,380",
        values: [
          1300,
          1877,
          2500,
          2577,
          2000,
          2100,
          3000,
          2700,
          3631,
          2471,
          2700,
          3631,
          2471
        ]
      },
      hoursWorked: {
        total: "319",
        values: [110, 150, 300, 130, 400, 240, 220, 310, 220, 300, 270, 210]
      },
      daysWorked: {
        total: "73",
        values: [5, 10, 7, 15, 22, 8, 10, 10, 15, 20, 21, 24]
      }
    };
  }

  render() {
    const className = this.props.className;
    const stats = this.getStats();
    return (
      <div className="col-xs-12 col-sm-5 col-md-5 col-lg-8">
        <ul id="sparks" className={className}>
          <li className="sparks-info">
            <h5 className="m-0">
              My Earnings
              <span className="txt-color-green"> {stats.earnings.total}</span>
            </h5>
            <Sparkline
              values={stats.earnings.values}
              className="txt-color-green hidden-mobile hidden-md hidden-sm"
            />
          </li>
          <li className="sparks-info">
            <h5 className="m-0">
              Days Worked
              <span className="txt-color-blue">
                <i className="fa fa-calendar" /> {stats.daysWorked.total}
              </span>
            </h5>
            <Sparkline
              values={stats.daysWorked.values}
              className="txt-color-blue hidden-mobile hidden-md hidden-sm"
            />
          </li>
          <li className="sparks-info">
            <h5 className="m-0">
              Hours Worked
              <span className="txt-color-purple">
                <i className="fa fa-clock-o" /> {stats.hoursWorked.total}
              </span>
            </h5>
            <Sparkline
                values={stats.hoursWorked.values}
                className="txt-color-purple hidden-mobile hidden-md hidden-sm"
            />
          </li>
        </ul>
      </div>
    );
  }
}
